define(["require", "exports", "tslib", "@arcgis/core/Graphic", "@arcgis/core/geometry/Point", "@arcgis/core/geometry/Polyline", "@arcgis/core/layers/GraphicsLayer", "@arcgis/core/rest/route", "@arcgis/core/rest/support/FeatureSet", "@arcgis/core/rest/support/RouteParameters", "@arcgis/core/symbols/PictureMarkerSymbol", "@arcgis/core/symbols/SimpleLineSymbol", "@arcgis/core/widgets/Sketch/SketchViewModel", "mobx-react", "react", "../../dist/assets/images/i_barrier.png", "../model/services/EventManager", "../store/RouteStore", "../store/StoreManager", "../utils/ColourUtil", "../utils/GeometryUtil", "../utils/SpatialReferenceFactory", "./blocks"], function (require, exports, tslib_1, Graphic_1, Point_1, Polyline_1, GraphicsLayer_1, route, FeatureSet_1, RouteParameters_1, PictureMarkerSymbol_1, SimpleLineSymbol_1, SketchViewModel_1, mobx_react_1, React, i_barrier_png_1, EventManager_1, RouteStore_1, StoreManager_1, ColourUtil_1, GeometryUtil_1, SpatialReferenceFactory_1, blocks_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EntityCreateByRouteView = void 0;
    Graphic_1 = tslib_1.__importDefault(Graphic_1);
    Point_1 = tslib_1.__importDefault(Point_1);
    Polyline_1 = tslib_1.__importDefault(Polyline_1);
    GraphicsLayer_1 = tslib_1.__importDefault(GraphicsLayer_1);
    route = tslib_1.__importStar(route);
    FeatureSet_1 = tslib_1.__importDefault(FeatureSet_1);
    RouteParameters_1 = tslib_1.__importDefault(RouteParameters_1);
    PictureMarkerSymbol_1 = tslib_1.__importDefault(PictureMarkerSymbol_1);
    SimpleLineSymbol_1 = tslib_1.__importDefault(SimpleLineSymbol_1);
    SketchViewModel_1 = tslib_1.__importDefault(SketchViewModel_1);
    React = tslib_1.__importStar(React);
    i_barrier_png_1 = tslib_1.__importDefault(i_barrier_png_1);
    let EntityCreateByRouteView = exports.EntityCreateByRouteView = class EntityCreateByRouteView extends React.Component {
        constructor(props) {
            super(props);
            Object.defineProperty(this, "draw", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onDrawComplete", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onMapClick", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onKeyDown", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onKeyUp", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "lastSuccessfullyPlottedRoute", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "stops", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "barriers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "graphicsLayerRoute", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "graphicsLayerPoints", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "barrierSymbol", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "routeSymbol", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "shiftKeyPressed", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "addStop", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.setState({ selectedTool: "stop" });
                    this.deactiveDrawTool();
                    this.activateDrawTool();
                }
            });
            Object.defineProperty(this, "addBarrier", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.setState({ selectedTool: "barrier" });
                    this.deactiveDrawTool();
                    this.activateDrawTool();
                }
            });
            Object.defineProperty(this, "addPointToRoute", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (e) => {
                    if (this.state.selectedTool == "stop") {
                        const id = `${this.stops.length + 1}`;
                        e.symbol = this.createStopSymbol(id);
                        e.attributes = { id, manual: this.shiftKeyPressed };
                        this.stops.push(e);
                    }
                    else if (this.state.selectedTool == "barrier") {
                        e.symbol = this.barrierSymbol;
                        this.barriers.push(e);
                    }
                    this.solveRoute();
                    this.activateDrawTool();
                }
            });
            Object.defineProperty(this, "cancel", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.deactiveDrawTool();
                    (0, RouteStore_1.openRoute)({ pathname: "/tasks" });
                }
            });
            Object.defineProperty(this, "reset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.setState({
                        enableSave: false
                    });
                    this.lastSuccessfullyPlottedRoute = null;
                    this.graphicsLayerRoute.removeAll();
                    this.graphicsLayerPoints.removeAll();
                    this.stops = [];
                    this.barriers = [];
                    this.deactiveDrawTool();
                }
            });
            Object.defineProperty(this, "save", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    this.deactiveDrawTool();
                    this.lastSuccessfullyPlottedRoute.geometry.spatialReference = SpatialReferenceFactory_1.SpatialReferenceFactory.GDA_1994;
                    const route = GeometryUtil_1.GeometryUtil.mergePolylineToSinglePath(this.lastSuccessfullyPlottedRoute.geometry);
                    (0, EventManager_1.notify)("Measuring route distance");
                    let routeDistance = yield GeometryUtil_1.GeometryUtil.measureLength(this.props.configStore.geometryServiceUrl, route, "kilometers");
                    (0, RouteStore_1.openRoute)({
                        type: "replace",
                        pathname: `/tp/create/save`,
                        state: {
                            route: route.toJSON(),
                            routeDistance: this.formatDistance(routeDistance)
                        }
                    });
                })
            });
            this.stops = [];
            this.barriers = [];
            this.graphicsLayerRoute = new GraphicsLayer_1.default({ id: "route" });
            this.graphicsLayerPoints = new GraphicsLayer_1.default({ id: "routeStops" });
            props.mapStore.Map.map.layers.add(this.graphicsLayerRoute);
            props.mapStore.Map.map.layers.add(this.graphicsLayerPoints);
            this.routeSymbol = new SimpleLineSymbol_1.default({
                style: "solid",
                color: ColourUtil_1.ColourUtil.PrimaryActive,
                width: 4
            });
            this.barrierSymbol = new PictureMarkerSymbol_1.default({
                url: i_barrier_png_1.default,
                width: 24,
                height: 24
            });
            this.state = {
                enableSave: false,
                selectedTool: "stop"
            };
        }
        componentDidMount() {
            this.draw = new SketchViewModel_1.default({
                view: this.props.mapStore.Map,
                layer: this.graphicsLayerPoints,
                defaultCreateOptions: {
                    mode: "click",
                },
                defaultUpdateOptions: {
                    enableRotation: false,
                    enableScaling: false,
                    enableZ: false,
                    multipleSelectionEnabled: false,
                    tool: "move"
                }
            });
            this.draw.on("create", e => {
                if (e.state == "complete") {
                    this.addPointToRoute(e.graphic);
                }
            });
            this.draw.on("update", e => {
                var _a;
                const vertexMoved = e.state == "active" && ((_a = e.toolEventInfo) === null || _a === void 0 ? void 0 : _a.type) == "move-stop";
                const notify = e.state == "complete" || vertexMoved;
                if (notify && !e.aborted) {
                    this.solveRoute();
                }
            });
            this.onKeyDown = this.props.mapStore.Map.on("key-down", e => {
                if (e.key == "Shift") {
                    console.log("shift key pressed");
                    this.shiftKeyPressed = true;
                }
            });
            this.onKeyUp = this.props.mapStore.Map.on("key-up", e => {
                if (e.key == "Shift") {
                    console.log("shift key unpressed");
                    this.shiftKeyPressed = false;
                }
            });
            this.onRightClick();
            this.addStop();
        }
        componentWillUnmount() {
            var _a, _b, _c;
            (_a = this === null || this === void 0 ? void 0 : this.onMapClick) === null || _a === void 0 ? void 0 : _a.remove();
            (_b = this === null || this === void 0 ? void 0 : this.onKeyDown) === null || _b === void 0 ? void 0 : _b.remove();
            (_c = this === null || this === void 0 ? void 0 : this.onKeyUp) === null || _c === void 0 ? void 0 : _c.remove();
            this.deactiveDrawTool();
            this.draw.destroy();
            this.props.mapStore.Map.map.remove(this.graphicsLayerRoute);
            this.props.mapStore.Map.map.remove(this.graphicsLayerPoints);
        }
        activateDrawTool() {
            console.info("activateDrawTool");
            this.draw.create("point");
        }
        resequenceStops() {
            this.stops.forEach((stop, index) => {
                stop.attributes.id = `${index + 1}`;
                stop.symbol = this.createStopSymbol(`${index + 1}`);
            });
        }
        deactiveDrawTool() {
            if (this.onDrawComplete) {
                this.onDrawComplete.remove();
            }
            this.draw.cancel();
        }
        render() {
            return (React.createElement(blocks_1.VGroup, null,
                React.createElement(blocks_1.Header, { title: "Create Travel Permit" },
                    React.createElement(blocks_1.HGroup, null,
                        React.createElement(blocks_1.HeaderButton, { label: "Accept", disabled: !this.state.enableSave, onClick: this.save }),
                        React.createElement(blocks_1.HeaderButton, { label: "Reset", disabled: false, onClick: this.reset }),
                        React.createElement(blocks_1.HeaderButton, { label: "Cancel", color: "secondary", onClick: this.cancel }))),
                React.createElement(blocks_1.VGroup, { className: "form", style: { alignItems: "flex-start" } },
                    React.createElement(blocks_1.HGroup, { style: { marginBottom: '10px' } },
                        React.createElement("div", null, "Using the map, digitise the Travel Route"),
                        React.createElement(blocks_1.Tooltip, { text: "Using the map, left click to plot a succession of points (stops) that define your desired travel route (hold SHIFT to force a point (stop) to be added to your route or use ESC to cancel adding stops). To move a stop, left click it, then move it with the mouse. To delete a stop, right click it." })),
                    React.createElement(blocks_1.CtaButton, { color: "primary", label: "Add Route Stop", onClick: this.addStop }),
                    React.createElement(blocks_1.CtaButton, { color: "primary", label: "Add Route Barrier", onClick: this.addBarrier }))));
        }
        onRightClick() {
            this.onMapClick = this.props.mapStore.Map.on("click", e => {
                if (e.button == 2) {
                    const screenPoint = { x: e.x, y: e.y };
                    this.props.mapStore.Map.hitTest(screenPoint).then(({ results }) => {
                        const graphicHits = results === null || results === void 0 ? void 0 : results.filter(x => x.type === "graphic").map(x => x.graphic);
                        for (let g of graphicHits) {
                            const selected = g;
                            if (selected.layer.id == "routeStops") {
                                this.graphicsLayerPoints.remove(selected);
                                const stopIndex = this.stops.indexOf(selected);
                                let barrierIndex = -1;
                                if (stopIndex !== -1) {
                                    this.stops.splice(stopIndex, 1);
                                    if (this.stops.length === 1) {
                                        this.graphicsLayerRoute.removeAll();
                                    }
                                }
                                else {
                                    barrierIndex = this.barriers.indexOf(selected);
                                    if (barrierIndex !== -1) {
                                        this.barriers.splice(barrierIndex, 1);
                                    }
                                }
                                if (stopIndex !== -1 || barrierIndex !== -1) {
                                    this.solveRoute();
                                }
                            }
                        }
                    });
                }
            });
        }
        solveRoute() {
            const createSegments = (stops) => {
                var _a;
                const segments = [];
                let currentSegmentType = null;
                let currentSegmentStops = [];
                for (let i = 0; i < stops.length; i++) {
                    const stop = stops[i];
                    const isManual = (_a = stop.attributes) === null || _a === void 0 ? void 0 : _a.manual;
                    const segmentType = isManual ? 'line' : 'route';
                    if (currentSegmentType === null) {
                        currentSegmentType = segmentType;
                        currentSegmentStops.push(stop);
                    }
                    else if (segmentType === currentSegmentType) {
                        currentSegmentStops.push(stop);
                    }
                    else {
                        if (currentSegmentStops.length >= 2) {
                            segments.push({
                                type: currentSegmentType,
                                stops: [...currentSegmentStops]
                            });
                        }
                        currentSegmentType = segmentType;
                        currentSegmentStops = [stops[i - 1], stop];
                    }
                }
                if (currentSegmentStops.length >= 2) {
                    segments.push({
                        type: currentSegmentType,
                        stops: [...currentSegmentStops]
                    });
                }
                return segments;
            };
            const processRouteSegmentUsingStraightLines = (stops) => {
                return new Promise((resolve) => {
                    const path = stops.map(stop => {
                        const point = new Point_1.default(stop.geometry);
                        return [point.x, point.y];
                    });
                    const polyline = new Polyline_1.default({
                        paths: [path],
                        spatialReference: stops[0].geometry.spatialReference
                    });
                    let simplifiedGeometry = GeometryUtil_1.GeometryUtil.simplify(polyline);
                    let generalizedGeometry = GeometryUtil_1.GeometryUtil.generalize(simplifiedGeometry, 0.0005, true);
                    appendToRoute(generalizedGeometry);
                    resolve();
                });
            };
            const processRouteSegmentUsingNA = (stops) => {
                return new Promise((resolve, reject) => {
                    const stopsFeatureSet = new FeatureSet_1.default();
                    stops.forEach(stop => stopsFeatureSet.features.push(stop));
                    const barriers = new FeatureSet_1.default();
                    this.barriers.forEach(barrier => barriers.features.push(barrier));
                    const routeTaskUrl = this.props.configStore.WebConfig.entityView.Core.CreateByRoute.NetworkAnalystServiceUrl;
                    const routeParams = new RouteParameters_1.default();
                    routeParams.returnStops = true;
                    routeParams.returnRoutes = true;
                    routeParams.returnDirections = true;
                    routeParams.directionsLengthUnits = "kilometers";
                    routeParams.impedanceAttribute = "Length";
                    routeParams.preserveFirstStop = true;
                    routeParams.preserveLastStop = true;
                    routeParams.findBestSequence = false;
                    routeParams.outSpatialReference = SpatialReferenceFactory_1.SpatialReferenceFactory.GDA_1994;
                    routeParams.stops = stopsFeatureSet;
                    routeParams.pointBarriers = barriers;
                    route.solve(routeTaskUrl, routeParams).then(res => {
                        if ("routeResults" in res) {
                            const routes = res.routeResults;
                            if (routes.length > 0) {
                                const { route, directions } = routes[0];
                                console.log({ segmentdidstance: directions.totalLength });
                                route.geometry = GeometryUtil_1.GeometryUtil.simplify(route.geometry);
                                route.geometry = GeometryUtil_1.GeometryUtil.generalize(route.geometry, 0.0005, true);
                                appendToRoute(route.geometry);
                                resolve();
                            }
                            else {
                                (0, EventManager_1.notify)("No routes found");
                                resolve();
                            }
                        }
                        else {
                            (0, EventManager_1.notify)("No routes found");
                            resolve();
                        }
                    }).catch(err => {
                        console.error(err);
                        reject(err);
                    });
                });
            };
            const appendToRoute = (geometry) => {
                if (this.lastSuccessfullyPlottedRoute) {
                    const existingPaths = this.lastSuccessfullyPlottedRoute.geometry.paths;
                    const newPaths = geometry.paths;
                    const combinedPaths = existingPaths.concat(newPaths);
                    this.lastSuccessfullyPlottedRoute.geometry = new Polyline_1.default({
                        paths: combinedPaths,
                        spatialReference: geometry.spatialReference
                    });
                }
                else {
                    this.lastSuccessfullyPlottedRoute = new Graphic_1.default({ geometry: geometry, symbol: this.routeSymbol });
                }
            };
            if (this.stops.length > 1) {
                const segments = createSegments(this.stops);
                console.log("createSegments", segments);
                this.lastSuccessfullyPlottedRoute = null;
                let promiseChain = Promise.resolve();
                segments.forEach(segment => {
                    promiseChain = promiseChain.then(() => {
                        if (segment.type === 'line') {
                            return processRouteSegmentUsingStraightLines(segment.stops);
                        }
                        else if (segment.type === 'route') {
                            return processRouteSegmentUsingNA(segment.stops);
                        }
                    });
                });
                promiseChain.then(() => {
                    this.graphicsLayerRoute.removeAll();
                    this.graphicsLayerRoute.add(this.lastSuccessfullyPlottedRoute);
                    this.setState({
                        enableSave: true
                    });
                }).catch(err => {
                    console.error(err);
                    (0, EventManager_1.notify)("Error processing route");
                });
            }
        }
        formatDistance(dist) {
            return Math.round(dist * 100) / 100;
        }
        createStopSymbol(text) {
            const w = 36;
            const x = w / 2;
            const y = x;
            const fontSize = Math.round(w * 0.6);
            const canvas = document.createElement("canvas");
            canvas.width = w;
            canvas.height = w;
            const ctx = canvas.getContext("2d");
            ctx.beginPath();
            ctx.fillStyle = `rgb(${ColourUtil_1.ColourUtil.PrimaryActive.r},${ColourUtil_1.ColourUtil.PrimaryActive.g},${ColourUtil_1.ColourUtil.PrimaryActive.b})`;
            ctx.arc(x, y, w / 2, 0, 2 * Math.PI, false);
            ctx.fill();
            ctx.font = `${fontSize}pt Arial`;
            ctx.fillStyle = "white";
            ctx.textAlign = "center";
            ctx.fillText(text, x, y + fontSize / 2);
            const dataURL = canvas.toDataURL();
            return new PictureMarkerSymbol_1.default({
                url: dataURL,
                width: w / 2,
                height: w / 2
            });
        }
    };
    exports.EntityCreateByRouteView = EntityCreateByRouteView = tslib_1.__decorate([
        (0, mobx_react_1.inject)(context => (0, StoreManager_1.injectStores)(context)),
        mobx_react_1.observer
    ], EntityCreateByRouteView);
});
